var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutdoorUnitIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 16.3334C10.878 16.4918 11.1239 16.5978 11.3842 16.6426C11.6444 16.6874 11.9116 16.6696 12.1637 16.5909C12.4158 16.5122 12.6455 16.3746 12.834 16.1897C13.0225 16.0047 13.1644 15.7776 13.2479 15.5271C13.3314 15.2766 13.3542 15.0098 13.3144 14.7487C13.2745 14.4876 13.1732 14.2398 13.0188 14.0255C12.8644 13.8113 12.6613 13.6368 12.4262 13.5165C12.1911 13.3961 11.9308 13.3334 11.6667 13.3334H1.66675",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5834 6.66671C14.7965 6.38261 15.0786 6.1577 15.4031 6.01332C15.7275 5.86895 16.0835 5.8099 16.4372 5.84179C16.7909 5.87368 17.1305 5.99545 17.4239 6.19554C17.7173 6.39563 17.9547 6.66739 18.1135 6.98501C18.2723 7.30264 18.3473 7.65559 18.3313 8.01035C18.3153 8.36511 18.209 8.7099 18.0223 9.01198C17.8356 9.31406 17.5748 9.56341 17.2646 9.73634C16.9544 9.90927 16.6052 10 16.2501 10H1.66675",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16675 3.66671C8.37802 3.50826 8.62392 3.40228 8.88418 3.3575C9.14444 3.31273 9.41162 3.33044 9.66369 3.40918C9.91577 3.48793 10.1455 3.62544 10.334 3.8104C10.5225 3.99536 10.6644 4.22246 10.7479 4.47299C10.8314 4.72353 10.8542 4.99032 10.8144 5.25139C10.7745 5.51245 10.6732 5.76032 10.5188 5.97456C10.3644 6.1888 10.1613 6.36327 9.92622 6.48361C9.69114 6.60395 9.43083 6.66671 9.16675 6.66671H1.66675",
    stroke: "#F54900",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoorUnitIcon);
export default __webpack_public_path__ + "static/media/outdoor_unit_icon.07a4cf7f6162f780b3ae3d0c9b75df92.svg";
export { ForwardRef as ReactComponent };